export const DEFAULT_PHONE_CODE = '+1';
export const PHONE_NUMBER_REGEX = /(\+?[0-9]{0,3})\(?([0-9]{3})\)?([ ]?)([0-9]{3})([ -]?)([0-9]{2})([ -]?)([0-9]{2})/;
export const VALID_PHONE_NUMBER_FORMATS = [
    'XXXXXXXXXX',
    '+XXXXXXXXXXX',
    '(XXX)XXXXXXX',
    '(XXX)XXX-XXXX',
    '(XXX)XXX-XX-XX',
    '(XXX) XXX XX XX',
    '+X(XXX)XXXXXXX',
    '+X(XXX)XXX-XXXX',
    '+X(XXX)XXX-XX-XX',
    '+X(XXX)XXX XX XX',
    'X(XXX)XXXXXXX',
    'X(XXX)XXX-XXXX',
    'X(XXX)XXX-XX-XX',
    'X(XXX)XXX XX XX',
];
//# sourceMappingURL=phone.js.map